module.exports = __webpack_public_path__ + "static/media/gal-2.baf3c3e1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Drone/gal-2.jpg
// module id = 305
// module chunks = 0